import { phone } from './phone.js';
import { phoneNANP } from './phoneNANP.js';
import { urlSafe } from './urlSafe.js';
import { currency } from './currency.js';
export const StringFormatter = {
    phone,
    phoneNANP,
    urlSafe,
    currency,
};
